<template>
  <tr class="clickable">
    <td>
      {{ role.id }}
    </td>
    <td>
      {{ role.title }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'RoleRow',
    props: {
      role: {
        type: Object,
        default: null
      }
    }
  }
</script>
